import { css } from 'styled-components';

export const WrapperMixin = () => css`
	border-radius: 999px;
	background-color: ${props => props.theme.colors.content.secondary};
	padding: ${props => props.theme.size.static200} ${props => props.theme.size.static250};
`;
